<div class="grid">
	<div class="col-12 sm:col-6" id="myself">
		<div class="grid">
			<div class="col-12"><ng-content /></div>
			<div class="col-12"><hr/></div>
			<div class="col-12">
				<app-input
					type="text"
					label="Nome:"
					id="name"
					[(value)]="name"
				/>
			</div>
			<div class="col-12">
				<app-input
					type="text"
					label="E-mail:"
					id="email"
					[(value)]="email"
				/>
		
			</div>
			<div class="col-8">
				<app-input
					type="text"
					label="Cidade:"
					id="city"
					[(value)]="city"
				/>
			</div>
			<div class="col-4">
				<app-input
					type="text"
					label="Estado:"
					id="state"
					[(value)]="state"
				/>
			</div>

			<div class="col-12" *ngIf="isMobile">
				<hr />
				<app-bet-input-list [bets]="list" />
			</div>

			<div class="col-12"><hr/></div>
			<div class="col-4 sm:col-2">
				<app-checkbox
					[required]="true"
					[switch]="true"
					[(value)]="accept"
					/>
			</div>
			<div class="col-8 sm:col-10">
				Aceito os <a (click)="goTermos()" class="termsLink">Termos de Uso</a> e <a (click)="goTermos()" class="termsLink">Política de Privacidade</a>.
			</div>
			<div class="col-12"><hr/></div>
			<div class="col-12">{{ cantSendRs() }}</div>
			<div class="col-12 captcha-container">
				<div  class="captcha">
					<re-captcha [siteKey]="captchaKey" (resolved)="captchaResolve($event)" />
				</div>
			</div>
			<div class="col-12">
				<app-button
					caption="Enviar lista!"
					extraClass="btn-success"
					[loading]="loading"
					[disabled]="loading"
					(action)="register()"
					/>
			</div>
			<div class="col-12 sm:col-6 dev" *ngIf="dev">
				<app-button
					caption="Random fill"
					(action)="fillUpTest()"
					/>
			</div>
			<div class="col-12 mt-4" *ngIf="loading">
				<app-big-loader />
			</div>
		</div>
	</div>

	<div class="col-12 sm:col-6 bet-input-list" *ngIf="!isMobile">
		<app-bet-input-list [bets]="list" />
	</div>
</div>
